
<template>
  <BasicTable
    v-loading="loading"
    :config="config"
    :data="data"
  />
</template>

<script setup>

const props = defineProps({
  tabTimeValue: {
    default: []
  },
})

const isDepositOptions = $computed(() => {
  return [
    {
      label: $t('public.true'),
      value: 0,
    },
    {
      label: $t('public.false'),
      value: 1,
    }
  ]
})

const isTradeOptions = [
  {
    label: $t('public.true'),
    value: 0,
  },
  {
    label: $t('public.false'),
    value: 1,
  }
]

let loading = $ref(false)
let data = $ref([])
const getData = async () => {
  try {
    loading = true
    const body = {}
    if (!isEmpty(props.tabTimeValue)) {
      body.startTime = props.tabTimeValue[0]
      body.endTime = props.tabTimeValue[1]
    }
    const d = await dataApi.newRegister(body)
    data = d
  } finally {
    loading = false
  }
}

// 表格配置
const config = $computed(() => {
  return [
    { label: 'uid', prop: 'uid', minWidth: 100 },
    { label: $t('form.inviteCode'), prop: 'inviteeCode', minWidth: 100 },
    { label: $t('public.registerTime'), prop: 'registerTime', type: 'time', width: 172 },
    { label: $t('public.isDeposit'), prop: 'isDeposit', options: isDepositOptions },
    { label: $t('public.isTrade'), prop: 'isTrade', options: isTradeOptions },
  ]
})

onBeforeMount(async () => {
  getData()
})

watch(() => props.tabTimeValue, () => {
  getData()
})
</script>

<style lang="scss">
</style>
